import i18n from '@modules/raccoon/src/i18nTranslator/i18next';

const getHint = (text) => ({
  hint: i18n.t(text)
});

export const getTextAreaEditorToolbar = (handleTextAreaHide) => [
  {
    formatName: 'showHtml',
    options: {
      icon: 'codeblock',
      onClick: handleTextAreaHide,
      hint: i18n.t('SchowajHtml')
    }
  }
];

const getHeaders = (maxHeader) => {
  return Array.from({ length: maxHeader > 6 ? 6 : maxHeader }, (_, i) => i + 1);
};

export const getHtmlEditorToolbar = (handleTextAreaShow, maxHeader) => [
  { formatName: 'bold', options: getHint('Pogrubienie') },
  { formatName: 'italic', options: getHint('Kursywa') },
  { formatName: 'color', options: getHint('Kolor') },
  { formatName: 'background', options: getHint('Tlo') },
  { formatName: 'link', options: getHint('Link') },
  { formatName: 'image', options: getHint('Zdjecie') },
  {
    formatName: 'showHtml',
    options: {
      icon: 'codeblock',
      onClick: handleTextAreaShow,
      hint: i18n.t('PokazHtml')
    }
  },
  {
    formatName: 'header',
    formatValues: [...getHeaders(maxHeader), false]
  },
  {
    formatName: 'orderedList',
    options: getHint('ListaNumerowana')
  },
  {
    formatName: 'bulletList',
    options: getHint('ListaWypunktowana')
  },
  {
    formatName: 'alignLeft',
    options: getHint('Wyrównaj do lewej')
  },  {
    formatName: 'alignCenter',
    options: getHint('Wycentruj')
  },  {
    formatName: 'alignRight',
    options: getHint('Wyrównaj do prawej')
  },  {
    formatName: 'alignJustify',
    options: getHint('Wyjustuj')
  }
];
